import React from "react";
//Global Style
import GlobalStyle from "./components/GlobalStyle";
//Import Pages
import AboutUs from "./pages/AboutUs";
import Gallery from "./pages/Gallery";
import OurWork from "./pages/OurWork";
import Nav from "./components/Nav";
import MovieDetail from "./pages/MovieDetail";
import Podcast from "./pages/Podcast";
import Weddings from "./pages/Weddings";
import Studio from "./pages/Studio";
//Router
import { Switch, Route, useLocation } from "react-router-dom";
//Animation
import { AnimatePresence } from "framer-motion";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <GlobalStyle />

      <Nav />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/" exact>
            <AboutUs />
          </Route>
          <Route path="/work" exact>
            <OurWork />
          </Route>
          <Route path="/work/:id">
            <MovieDetail />
          </Route>
          <Route path="/gallery" exact>
            <Gallery />
          </Route>
          <Route path="/weddings" exact>
            <Weddings />
          </Route>
          <Route path="/studio" exact>
            <Studio />
          </Route>
          <Route path="/podcast" exact>
            <Podcast />
          </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
